import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { AccountDocument, DocumentType } from 'src/models/account-document.model';
import { OrganizationRequiredDocument, DocumentRequiredOn } from 'src/models/organization-required-document';
// import { SecureMissingDocumentsComponent } from 'src/app/shared-components/secure-missing-documents/secure-missing-documents.component';
import { MediaService } from './media.service';
import { SearchDocumentsRequest, SearchDocumentsResponse } from 'src/models/account.model';
import { Organization } from 'src/models/organization';

@Injectable({
    providedIn: 'root'
})
export class DocumentService {
  constructor(
    private api: ApiService,
    private mediaService: MediaService
  ) { }

  async getRequiredDocument(id: number) {
    return this.api.get<OrganizationRequiredDocument>(
      `${this.api.endpoints.documents}/GetRequiredDocument?id=${id}`,
    );
  }

  async getRequiredDocumentsForOrgs(ids: number[]): Promise<OrganizationRequiredDocument[]> {
    return this.api.post<OrganizationRequiredDocument[]>(
      this.api.endpoints.documents + '/getRequiredDocumentsForOrgs',
      ids
    );
  }
  
  async addRequiredDocument(orgId: number, item: OrganizationRequiredDocument) {
    return this.api.post<OrganizationRequiredDocument>(
      `${this.api.endpoints.documents}/addRequiredDocument?orgId=${orgId}`,
      item,
    );
  }

  async updateRequiredDocuments(orgId: number, items: OrganizationRequiredDocument[]) {
    return this.api.post<OrganizationRequiredDocument[]>(
      `${this.api.endpoints.documents}/updateRequiredDocuments?orgId=${orgId}`,
      items,
    );
  }

  async deleteRequiredDocuments(orgId: number, ids: number[]) {
    return this.api.post(
      `${this.api.endpoints.documents}/deleteRequiredDocuments?orgId=${orgId}`,
      ids,
    );
  }

  async getAccountsDocuments(ids: number[]): Promise<AccountDocument[]> {
      return this.api.post<AccountDocument[]>(
        `${this.api.endpoints.documents}/getAccountsDocuments`,
        ids
      );
  }

  async getMissingAccountDocuments(accountId: number, orgIds: number[]): Promise<AccountDocument[]> {
      return this.api.post<AccountDocument[]>(
        `${this.api.endpoints.documents}/getMissingAccountDocuments?accountId=${accountId}`,
        orgIds
      );
  }

  async addAccountDocument(accountDoc: AccountDocument): Promise<AccountDocument> {
      return this.api.post<AccountDocument>(
        `${this.api.endpoints.documents}/addAccountDocument`,
        accountDoc
      );
  }

  async updateAccountDocument(accountDoc: AccountDocument): Promise<AccountDocument> {
      return this.api.post<AccountDocument>(
        `${this.api.endpoints.documents}/updateAccountDocument`,
        accountDoc
      );
  }

  async deleteAccountDocuments(ids: number[]) {
      return this.api.post(
        `${this.api.endpoints.documents}/deleteAccountDocuments`,
        ids
      );
  }

  async generateAllAccountsDocuments(filters: SearchDocumentsRequest){
    return this.api.post<AccountDocument[]>(
        `${this.api.endpoints.documents}/generateAllAccountsDocuments`,
        filters
    )
  }

  async handleOrgDocUpload(org: Organization, document: OrganizationRequiredDocument) {
    const selectedBtn = await this.mediaService.presentUploadOptions();

    if (!selectedBtn.role || selectedBtn.role === 'cancel' || selectedBtn.role === 'backdrop') {
      return false;
    } 

    console.log('document', document);
  
    const fileName = this.mediaService.generateFileName(org?.name, document.name);
    console.log('filename', fileName);
  
    const result = selectedBtn.role === 'image'
      ? await this.mediaService.handleImageUpload(fileName, 0, false)
      : selectedBtn.role === 'file'
        ? await this.mediaService.handlePdfUpload(fileName, 0) : false;
    
    if (result) {
      document.url = result;
      return document.url;
    }
  
    return false;
  }

  async handleAccountDocUpload(document: AccountDocument, accountId: number, orgName?: string, requiredDocName?: string) {
    console.log('document', document);
    const selectedBtn = await this.mediaService.presentUploadOptions();

    if (!selectedBtn.role || selectedBtn.role === 'cancel' || selectedBtn.role === 'backdrop') {
      return false;
    } 


    // checking 'document.documentType' does not work 
    // Error: 'This comparison appears to be unintentional because the types 'DocumentType.BirthCertificate' and 'DocumentType.TaxDocument' have no overlap.'
    if (!requiredDocName && document.documentType !== undefined && document.documentType !== null) {
      if (document.documentType === DocumentType.TaxDocument) {
        requiredDocName = 'Tax Document';
      } else if (document.documentType === DocumentType.BirthCertificate) {
        requiredDocName = 'Birth Certificate';
      }
    }

    const fileName = this.mediaService.generateFileName(
      orgName,
      requiredDocName);

    const result = selectedBtn.role === 'image'
      ? await this.mediaService.handleImageUpload(fileName, accountId, false)
      : selectedBtn.role === 'file'
        ? await this.mediaService.handlePdfUpload(fileName, accountId) : false;

    if (result) {
      document.fileName = result;

      if (document.id === 0) {
        await this.addAccountDocument(document);
      } else {
        await this.updateAccountDocument(document);
      }

      return true;
    }

    return false;
  }
}
